import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { userSchema, type LoginRequest } from '@witty-board/shared'
import { apiRequest, apiRequestVoid } from './client.js'

export const meQueryKey = ['auth', 'me'] as const

export function useMeQuery() {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => apiRequest('/auth/me', userSchema),
    retry: false,
  })
}

export function useLoginMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (credentials: LoginRequest) =>
      apiRequest('/auth/login', userSchema, { method: 'POST', body: credentials }),
    onSuccess: (user) => {
      queryClient.setQueryData(meQueryKey, user)
    },
  })
}

export function useLogoutMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => apiRequestVoid('/auth/logout', { method: 'POST' }),
    onSettled: () => {
      queryClient.setQueryData(meQueryKey, null)
      queryClient.clear()
    },
  })
}
